import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { PresetContainer, PresetField, PresetFooter } from 'shared/Preset'
import { Button, Typography } from 'shared/ui'
import { type RowClient } from 'entities/Clients/model/RowClient'
import { TeamsSelectField } from 'pages/clients/ui/shared/TeamsSelectField/ui/TeamsSelectField'
import type { TeamsSelectFieldStore } from 'pages/clients/ui/shared/TeamsSelectField/store/teamsSelectFieldStore'

type IManageTeamsModalProps = {
  row: RowClient
  onClose: () => void
  handleSave: (selectedTeamIds: number[]) => Promise<void>
  handleDisconnectTeams: () => void
  store: TeamsSelectFieldStore
}

export const ManageTeamsModal = observer(
  ({ row, onClose, handleSave, handleDisconnectTeams, store }: IManageTeamsModalProps) => {
    const [isSaving, setIsSaving] = useState(false)
    const { selectedTeamIds } = store

    const handleOnSave = async () => {
      setIsSaving(true)
      await handleSave(selectedTeamIds)
      setIsSaving(false)
    }

    return (
      <PresetContainer>
        <PresetField>
          <Typography
            variant={'body-md-medium'}
            ellipsis
            ariaLabel={'ClientGroupName'}
            marginTop={'12px'}
            marginBottom={'8px'}
          >
            {row.clientName}
          </Typography>
          <TeamsSelectField
            store={store}
            onDisconnectAllTeams={handleDisconnectTeams}
            isDisconnectBtnVisible={!!row.origin.groups?.length}
          />
        </PresetField>
        <PresetFooter>
          <Button text='Cancel' size='medium' contained='secondary' onClick={onClose} />
          <Button
            text='Save'
            size='medium'
            disabled={(!row.origin.groups?.length && !selectedTeamIds.length) || isSaving}
            onClick={handleOnSave}
          />
        </PresetFooter>
      </PresetContainer>
    )
  }
)
